"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _idbReactTranslations = require("@identitybuilding/idb-react-translations");

var _idbReactTranslations2 = _interopRequireDefault(_idbReactTranslations);

var _idbReactUiElements = require("@identitybuilding/idb-react-ui-elements");

var _axios = require("axios");

var _axios2 = _interopRequireDefault(_axios);

var _idbReactIconlib = require("@identitybuilding/idb-react-iconlib");

var _idbReactIconlib2 = _interopRequireDefault(_idbReactIconlib);

var _mijnStadGemeente_fr = require("../images/mijn.stad-gemeente_fr.svg");

var _mijnStadGemeente_fr2 = _interopRequireDefault(_mijnStadGemeente_fr);

var _mijnStadGemeente_nl = require("../images/mijn.stad-gemeente_nl.svg");

var _mijnStadGemeente_nl2 = _interopRequireDefault(_mijnStadGemeente_nl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Sidebar = function Sidebar(props) {
  var _useState = (0, _react.useState)(""),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      suggestions = _useState2[0],
      setSuggestions = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
      typingTimeout = _useState4[0],
      setTypingTimeout = _useState4[1];

  var _useState5 = (0, _react.useState)(""),
      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
      searchValue = _useState6[0],
      setSearchValue = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray3.default)(_useState7, 2),
      visibleText = _useState8[0],
      setVisibleText = _useState8[1];

  var translate = function translate(e) {
    return (0, _idbReactTranslations2.default)(e, props.lang);
  };

  var CancelToken = _axios2.default.CancelToken;
  var source = CancelToken.source();

  var searchNis = function searchNis(e) {
    setSuggestions("");
    if (typingTimeout) clearTimeout(typingTimeout);
    setTimeout((0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              source.cancel();

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, undefined);
    })), 1000);
    var value = "";
    if (e) {
      setSearchValue(e.target.value);
      // value = e.target.value.replace('La ', '');
      value = e.target.value;
    }

    setTypingTimeout(setTimeout(function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(e) {
        var as_model, stringFields, numberFields, post_filter, option, data, _suggestions;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                as_model = require("../models/index.js").default;
                stringFields = ["name_nl", "name_fr", "name_de", "name_en", "alt_name_nl", "alt_name_fr", "submunicipality_set.alt_name_fr", "submunicipality_set.alt_name_nl", "submunicipality_set.name_nl", "submunicipality_set.name_fr", "submunicipality_set.name_de", "submunicipality_set.name_en", "nis_code", "nis_code_1970", "nis_code_1977", "submunicipality_set.nis_code_1970", "submunicipality_set.nis_code_1977"];
                numberFields = ["pkancode", "nis_code", "nis_code_1970", "nis_code_1977", "submunicipality_set.pkancode", "submunicipality_set.nis_code_1970", "submunicipality_set.nis_code_1977"];
                post_filter = props.type === 'vlaanderen' ? {
                  "bool": {
                    "should": [{
                      "term": {
                        "region.nis_code": "4000"
                      }
                    }, {
                      "term": {
                        "region.nis_code": "2000"
                      }
                    }]
                  }
                } : {
                  "bool": {
                    "should": [{
                      "term": {
                        "region.nis_code": "4000"
                      }
                    }, {
                      "term": {
                        "region.nis_code": "3000"
                      }
                    }, {
                      "term": {
                        "region.nis_code": "2000"
                      }
                    }]
                  }
                };
                option = {};

                if (isNaN(value)) {
                  option = {
                    from: 0,
                    size: 581,
                    query: {
                      bool: {
                        should: [{
                          query_string: {
                            query: "\"" + value + "\"",

                            fields: stringFields,
                            tie_breaker: 0.3
                          }
                        }, {
                          query_string: {
                            query: "*" + value + "*",

                            fields: stringFields,
                            tie_breaker: 0.3
                          }
                        }, {
                          query_string: {
                            query: "" + value,

                            fields: stringFields,
                            tie_breaker: 0.3
                          }
                        }]
                      }

                    },
                    sort: [
                      // {
                      //   pkancode: {
                      //     order: "asc",
                      //   },
                      // },
                    ],
                    post_filter: post_filter
                  };
                } else {
                  option = {
                    size: 581,
                    query: {
                      query_string: {
                        query: "\"" + value + "\"",
                        fields: numberFields,
                        tie_breaker: 0.3
                      }
                    },
                    sort: [{
                      pkancode: {
                        order: "asc"
                      }
                    }],
                    post_filter: post_filter
                  };
                }

                if (!value) {
                  _context2.next = 12;
                  break;
                }

                data = [];
                _context2.next = 10;
                return _axios2.default.get("https://search-osn-management-hkfarflgp5aj2vbhfzvmyycuuy.eu-central-1.es.amazonaws.com/municipalities/_search", {
                  auth: {
                    username: "osn-admin",
                    password: "O15s19n14!+"
                  },
                  params: {
                    source_content_type: "application/json",
                    source: (0, _stringify2.default)(option)
                  },
                  cancelToken: source.token
                }).then(function (res) {
                  data = as_model(res.data.hits.hits, props.lang, translate, value, props.MyCity);
                  return data;
                }).catch(function (error) {
                  console.log(error);
                });

              case 10:
                _suggestions = _context2.sent;

                if (_suggestions && _suggestions.length > 0) {
                  setSuggestions(_suggestions);
                }

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, undefined);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), 500));
  };

  var openUrl = function openUrl(e, i) {
    var name = e.name;
    // .replace('â', 'a')
    //   .replace(" (stad)", "")
    //   .replace(" (ville)", "")
    //   .replace(" (stadt)", "")
    //   .replace(" city", "")
    //   .replace(/\ /g, "")
    //   .replace("'", "");
    if (name === "sgravenbrakel") {
      name = "s-gravenbrakel";
    }
    if (name === "Mont-de-lEnclus") {
      name = "montdelenclus";
    }
    if (name === "LesBonsVillers") {
      name = "les-bons-villers";
    }

    var parent = e.parent && e.parent.replace(" (stad)", "").replace(" (ville)", "").replace(" (stadt)", "").replace(" city", "").replace(/\ /g, "").replace("'", "");
    if (parent === "sgravenbrakel") {
      parent = "s-gravenbrakel";
    }
    if (parent === "Mont-de-lEnclus") {
      parent = "montdelenclus";
    }
    if (name === "LesBonsVillers") {
      name = "les-bons-villers";
    }

    if (e.parent_slug && e.type === "municipality") {
      parent = e.parent_slug.toLowerCase();
    }
    // else if (e.parent_slug) {
    //     await axios.get(`https://api.ondernemersnetwerk.be/location/nis/by-name/${e.parent_slug}`)
    //         .then((res) => {
    //             let as_model = require(`../models/index.js`).default;
    //             let data = as_model(res.data, props.lang, translate)
    //             parent = data[0].name.toLowerCase()
    //         })
    // }

    // if (e.type === 'submunicipality') { window.open(`https://${parent.replace('-1', '').replace('-2', '')}.${props.baseUrl}`) }
    // else if (e.parent_slug && e.type === 'municipality') { window.open(`https://${parent.replace('-1', '').replace('-2', '')}.${props.baseUrl}`) }
    // else { window.open(`https://${name.replace('-1', '').replace('-2', '')}.${props.baseUrl}`) }
    if (e.postal_code == "9100" || e.postal_code == "9111" || e.postal_code == "9112") {
      return "https://sint-niklaas." + props.baseUrl;
    }

    // all postcodes of the submunicipalities redirects to the municipality site
    return "https://" + e.postal_code + "." + props.baseUrl;
  };

  return _react2.default.createElement(
    "div",
    { className: "mapDrawer " + (props.MyCity ? "MyCity" : "") + "  " + (props.className ? props.className : "") },
    props.MyCity ? _react2.default.createElement(
      "div",
      { className: "mapDrawerTop info city" },
      _react2.default.createElement("img", {
        id: "procentLogo",
        className: "city",
        src: "https://zappa-tlaqv351d.s3.amazonaws.com/media/brand/l/mijn_stad-gemeente.png",
        alt: "Logo of 100% lokaal"
      }),
      props.lang === 'nl' ?
      // <div className="cityLogo" dangerouslySetInnerHTML={{ __html: StadGemeente }} />
      _react2.default.createElement("img", {
        className: "cityLogo",
        src: "https://o-sn.be/kml/stad-gemeente_nl.svg",
        alt: "Logo of 100% lokaal"
      }) :
      // <div className="cityLogo" dangerouslySetInnerHTML={{ __html: VilleCommune }} />
      _react2.default.createElement("img", {
        className: "cityLogo",
        src: "https://o-sn.be/kml/stad-gemeente_fr.svg",
        alt: "Logo of 100% lokaal"
      })
    ) : _react2.default.createElement(
      "div",
      { className: "mapDrawerTop info" },
      _react2.default.createElement("img", {
        id: "procentLogo",
        src: require("../images/" + (props.lang === "nl" ? "logo.png" : "logo_fr.png")),
        alt: "Logo of 100% lokaal"
      }),
      !props.MyCity && _react2.default.createElement(
        "span",
        null,
        translate("in_colaberation_with")
      )
    ),
    _react2.default.createElement(
      "div",
      { className: "searchbar_wrapper" },
      _react2.default.createElement(
        "div",
        { className: "searchbar" },
        _react2.default.createElement(_idbReactUiElements.OsnInputText, {
          className: "searchMunicipality",
          label: translate("search"),
          icon: "Search",
          placeholder: translate("search"),
          template: 1
          // onKeyDown={() =>
          //   setTimeout(() => {
          //     searchNis();
          //   }, 500)
          // }
          , onChange: function onChange(e) {
            return searchNis(e);
          },
          close: true
        }),
        props.MyCity ? _react2.default.createElement(_idbReactUiElements.OsnSelect, {
          active: props.lang.toUpperCase(),
          options: [{ id: 1, name: "NL" }, { id: 2, name: "FR" }],
          onChange: function onChange(e) {
            return e.name === "NL" ? window.location.href = 'https://mijn.stad-gemeente.be' : window.location.href = "https://ma.ville-commune.be";
          }
        }) : _react2.default.createElement(_idbReactUiElements.OsnSelect, {
          active: window.location.hostname === "www.100procentlokaal.be" || window.location.hostname === "vlaanderen.100procentlokaal.be" ? "NL" : "FR",
          options: [{ id: 1, name: "NL" }, { id: 2, name: "FR" }],
          onChange: function onChange(e) {
            if (props.type === 'vlaanderen') {
              e.name === "NL" ? window.location.href = 'https://vlaanderen.100procentlokaal.be' : window.location.href = "https://flandre.100pourcentlocale.be";
            } else {
              e.name === "NL" ? window.location.href = 'https://www.100procentlokaal.be' : window.location.href = "https://www.100pourcentlocale.be";
            }
          }
        })
      ),
      searchValue && suggestions && suggestions.length > 0 ? _react2.default.createElement(
        "div",
        { className: "auto_suggestion_wrapper" },
        suggestions.map(function (res, index) {
          return props.getData ? _react2.default.createElement(
            "a",
            {
              key: index,
              className: "auto_suggestion " + res.type,
              onClick: function onClick() {
                return props.getData(res);
              }
            },
            _react2.default.createElement(
              "span",
              null,
              res.text
            )
          ) : _react2.default.createElement(
            "a",
            {
              key: index,
              className: "auto_suggestion " + res.type,
              href: openUrl(res, index),
              rel: "nofollow noopener noreferrer",
              target: "_blank"
            },
            _react2.default.createElement(
              "span",
              null,
              res.text
            )
          );
        })
      ) : translate("search_municipality")
    ),
    props.MyCity && props.MyCity === true ? _react2.default.createElement(
      "div",
      { className: "MyCity_text" },
      _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "p",
          null,
          translate('your_city_or_municipality_has_a_lot_to_tell_you')
        ),
        _react2.default.createElement(
          "p",
          null,
          translate('do_you_also_want_to_stay_informed')
        ),
        _react2.default.createElement("span", { className: "p" })
      ),
      _react2.default.createElement(
        "div",
        { className: "button_wrapper" },
        !props.hideLoginButton && _react2.default.createElement(_idbReactUiElements.Button, {
          borderColor: "cn",
          text: props.lang === 'nl' ? 'login' : 'connection',
          txtColor: "cn",
          type: "sub",
          size: "S",
          onClick: function onClick(e) {
            return props.login(e);
          }
        }),
        _react2.default.createElement(_idbReactUiElements.Button, {
          borderColor: "cn",
          text: props.lang === 'nl' ? 'Ga naar 100% Lokaal' : 'Allez à 100% local',
          txtColor: "cn",
          type: "sub",
          size: "S",
          url: props.lang === 'nl' ? 'https://www.100procentlokaal.be/' : 'https://www.100pourcentlocale.be/'
        })
      )
    ) : _react2.default.createElement(
      "div",
      { style: { display: "flex", flexDirection: "column" } },
      _react2.default.createElement(
        "video",
        { className: "video", autoPlay: true, controls: true, muted: true },
        props.type === 'vlaanderen' ? _react2.default.createElement("source", {
          src: "https://o-sn.be/seg/vlaanderen.100procentlokaal.be%20-%20voor-steden-en-gemeenten.mp4",
          type: "video/mp4"
        }) : _react2.default.createElement("source", {
          src: props.lang === 'nl' ? "https://o-sn.be/seg/www.100procentlokaal.be%20-%20voor-steden-en-gemeenten.mp4" : "https://o-sn.be/seg/100pourcentlocal.be-pour-villes-et-communes.mp4",
          type: "video/mp4"
        })
      ),
      _react2.default.createElement(
        "div",
        { className: "mapOptions" },
        _react2.default.createElement(
          "h2",
          null,
          translate("borders")
        ),
        props.type === 'vlaanderen' ? props.borders.filter(function (border) {
          return border.name !== 'regions';
        }).map(function (border, index) {
          return _react2.default.createElement(_idbReactUiElements.OsnCheckbox, {
            key: index,
            checked: border.active,
            name: translate(border.name),
            onChange: function onChange() {
              return props.checkboxHandler(border, props.type === 'vlaanderen' ? index + 1 : index);
            },
            value: translate(border.name),
            className: border.name
          });
        }) : props.borders.map(function (border, index) {
          return _react2.default.createElement(_idbReactUiElements.OsnCheckbox, {
            key: index,
            checked: border.active,
            name: translate(border.name),
            onChange: function onChange() {
              return props.checkboxHandler(border, index);
            },
            value: translate(border.name),
            className: border.name
          });
        })
      ),
      _react2.default.createElement(
        "div",
        { className: "mapOptions" },
        _react2.default.createElement(_idbReactUiElements.OsnCheckbox, {
          checked: props.baseLayer,
          name: translate("map"),
          onChange: function onChange() {
            return props.setBaseLayer(!props.baseLayer);
          },
          value: translate("map")
        }),
        _react2.default.createElement(_idbReactUiElements.OsnCheckbox, {
          checked: props.baseNames,
          name: translate("municipality_names"),
          onChange: function onChange() {
            return props.setBaseNames(!props.baseNames);
          },
          value: translate("municipality_names")
        })
      ),
      _react2.default.createElement("div", { id: "custom-map-controls" })
    )
  );
};

exports.default = Sidebar;